import { motion } from "framer-motion";
import { SOLUTIONS } from "@/lib/data";
import { useSEO } from "@/hooks/useSEO";

export default function Solutions() {
  useSEO({
    title: "Solutions — Trade Lifecycle · Risk · Analytics · AI | EnPrex Services",
    description: "End-to-end coverage of the trade lifecycle — trade capture, risk, scheduling, logistics, settlements, market & credit risk, regulatory reporting, analytics and AI.",
    path: "/solutions",
  });
  return (
    <div data-testid="solutions-page">
      <section className="container-x pt-24 pb-16 border-b border-white/5">
        <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7 }}>
          <div className="text-[11px] font-bold uppercase tracking-[0.3em] text-[#D4AF37] mb-6 font-mono">— Solutions</div>
          <h1 className="font-display text-5xl md:text-7xl font-light text-white tracking-tighter leading-[0.95] max-w-4xl">
            End-to-end coverage of the <span className="italic">trade lifecycle</span>.
          </h1>
        </motion.div>
      </section>

      <section className="container-x py-16">
        <div className="grid md:grid-cols-2 gap-6">
          {SOLUTIONS.map((sol, i) => {
            const Icon = sol.icon;
            return (
              <motion.div
                key={sol.title}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: (i % 4) * 0.05 }}
                className="border border-white/5 bg-white/[0.02] p-8 md:p-10 hover:border-[#D4AF37]/40 hover:bg-white/[0.04] transition-all group flex gap-6"
                data-testid={`solution-${sol.title.toLowerCase().replace(/\s+/g, "-")}`}
              >
                <div className="w-14 h-14 flex-shrink-0 border border-[#D4AF37]/40 flex items-center justify-center group-hover:bg-[#D4AF37]/10 transition-colors">
                  <Icon className="text-[#D4AF37]" size={22} strokeWidth={1.3} />
                </div>
                <div>
                  <div className="font-mono text-[10px] uppercase tracking-widest text-slate-500 mb-2">
                    {String(i + 1).padStart(2, "0")} / 10
                  </div>
                  <h3 className="font-display text-2xl text-white font-medium">{sol.title}</h3>
                  <p className="mt-3 text-sm text-slate-400 leading-relaxed">{sol.desc}</p>
                </div>
              </motion.div>
            );
          })}
        </div>
      </section>
    </div>
  );
}
